
import Vue from 'vue';
import { Component, Inject, Prop, Emit, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

import { Week, Task, DisplayOptions, TaskDay, ProjectDay, Employee } from '@/types/store-types';

import DayComponent from '@/components/day.vue';
import { DayInfo } from '@/models/task-day';

const project = namespace('project');

@Component({ components: { DayComponent } })
export default class WeekComponent extends Vue {
  @project.Getter('displayOptions')
  private displayOptions: DisplayOptions;

  @project.Getter('days')
  private days: TaskDay[];

  @Prop()
  private tasks: Task[];

  @Prop()
  private week: Week;

  @project.Getter('tasks')
  private allTasks: Task[];

  @project.Getter('employees')
  private employee: Employee[];

  @project.Action('closeWeek')
  private closeWeek(d: Date) {
  }

  get closed(): boolean {
    return this.week.closed;
  }

  get Title(): string {
    return this.closed ? `${this.$t('weeks.weekShort').toString()}${this.week.weekNumber}` : `${this.$t('weeks.week').toString()} ${this.week.weekNumber}`;
  }

  get Dates(): ProjectDay[] {
    if (this.week.closed) {
      return [];
    }
    return this.displayOptions.showWeekend ? this.week.days : this.week.days.slice(0, 5);
  }

  private taskIndex(task: Task): number {
    return this.allTasks.findIndex((t) => t.taskId === task.taskId);
  }

  private getWeekTotal(task: Task): string {
    let total = 0;
    this.week.days.forEach((d) => { total += (this.getDay(d, task, undefined)).plannedHours; });
    return total > 0 ? total.toString() : '';
  }

  private getEmployee(id: string): Employee | undefined {
    return this.employee.find((e) => e.employeeId === id);
  }

  private getDay(projectDay: ProjectDay, task: Task, employee: Employee | undefined): DayInfo {
    if (projectDay.day < task.startDate || (task.endDate && projectDay.day > task.endDate)) {
      return {
        taskId: task.taskId,
        taskDayId: '',
        day: projectDay.day,
        plannedHours: 0,
        available: 0,
        disabled: true,
      };
    }

    let dayDisabled = false;
    if (!task.newTask) {
      if (employee) {
        dayDisabled = (employee.startDate && projectDay.day < employee.startDate) ||
                              (employee.endDate && projectDay.day > employee.endDate) ||
                              employee.unplannable.findIndex((u) => u.getTime() === projectDay.day.getTime()) >= 0;
      }
    }

    const taskDay = this.days.find((d) => d.day.getTime() === projectDay.day.getTime() && d.taskId === task.taskId);
    if (taskDay) {
      return {
        ...taskDay,
        disabled: dayDisabled,
      };
    }

    return {
      taskId: task.taskId,
      taskDayId: '',
      day: projectDay.day,
      plannedHours: 0,
      available: 0,
      disabled: dayDisabled,
    };
  }
}
